export const ADMIN_MODULE_TRANSLATIONS = {
  es: {
    admin: {
      common: {
        search: 'Buscar...',
        new: 'Nuevo',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        loading: 'Cargando...',
        clear: 'Limpiar',
      },
      products: {
        title: 'Productos',
        types: 'Tipos',
        newProduct: 'Nuevo Producto',
        productsTab: 'Productos',
        stockTab: 'Stock y Disponibilidad',
        updated: 'Producto actualizado',
        created: 'Producto creado',
        deleteConfirm: 'Eliminar producto?',
        deleted: 'Producto eliminado',
        availabilityUpdated: 'Disponibilidad actualizada',
        viewInStore: 'Ver en la tienda',
      },
      events: {
        eventUpdated: 'Evento actualizado',
        eventCreated: 'Evento creado',
        tournamentTypeGroups: 'Fase de grupos + Eliminatoria',
        tournamentTypeLeague: 'Liga (todos contra todos)',
        tournamentTypeSwiss: 'Sistema suizo (balanceado)',
      },
    },
  },
  en: {
    admin: {
      common: {
        search: 'Search...',
        new: 'New',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        loading: 'Loading...',
        clear: 'Clear',
      },
      products: {
        title: 'Products',
        types: 'Types',
        newProduct: 'New Product',
        productsTab: 'Products',
        stockTab: 'Stock & Availability',
        updated: 'Product updated',
        created: 'Product created',
        deleteConfirm: 'Delete product?',
        deleted: 'Product deleted',
        availabilityUpdated: 'Availability updated',
        viewInStore: 'View in store',
      },
      events: {
        eventUpdated: 'Event updated',
        eventCreated: 'Event created',
        tournamentTypeGroups: 'Group Stage + Elimination',
        tournamentTypeLeague: 'League (round-robin)',
        tournamentTypeSwiss: 'Swiss System (balanced)',
      },
    },
  },
  fr: {
    admin: {
      common: {
        search: 'Rechercher...',
        new: 'Nouveau',
        edit: 'Modifier',
        delete: 'Supprimer',
        save: 'Enregistrer',
        cancel: 'Annuler',
        loading: 'Chargement...',
        clear: 'Effacer',
      },
      products: {
        title: 'Produits',
        types: 'Types',
        newProduct: 'Nouveau Produit',
        productsTab: 'Produits',
        stockTab: 'Stock et disponibilite',
        updated: 'Produit mis a jour',
        created: 'Produit cree',
        deleteConfirm: 'Supprimer le produit ?',
        deleted: 'Produit supprime',
        availabilityUpdated: 'Disponibilite mise a jour',
        viewInStore: 'Voir en boutique',
      },
      events: {
        eventUpdated: 'Evenement mis a jour',
        eventCreated: 'Evenement cree',
        tournamentTypeGroups: 'Phase de groupes + elimination',
        tournamentTypeLeague: 'Ligue (tous contre tous)',
        tournamentTypeSwiss: 'Systeme suisse (equilibre)',
      },
    },
  },
  pt: {
    admin: {
      common: {
        search: 'Pesquisar...',
        new: 'Novo',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        loading: 'Carregando...',
        clear: 'Limpar',
      },
      products: {
        title: 'Produtos',
        types: 'Tipos',
        newProduct: 'Novo Produto',
        productsTab: 'Produtos',
        stockTab: 'Stock e Disponibilidade',
        updated: 'Produto atualizado',
        created: 'Produto criado',
        deleteConfirm: 'Eliminar produto?',
        deleted: 'Produto eliminado',
        availabilityUpdated: 'Disponibilidade atualizada',
        viewInStore: 'Ver na loja',
      },
      events: {
        eventUpdated: 'Evento atualizado',
        eventCreated: 'Evento criado',
        tournamentTypeGroups: 'Fase de grupos + eliminacao',
        tournamentTypeLeague: 'Liga (todos contra todos)',
        tournamentTypeSwiss: 'Sistema suico (equilibrado)',
      },
    },
  },
  de: {
    admin: {
      common: {
        search: 'Suchen...',
        new: 'Neu',
        edit: 'Bearbeiten',
        delete: 'Loschen',
        save: 'Speichern',
        cancel: 'Abbrechen',
        loading: 'Laden...',
        clear: 'Zurucksetzen',
      },
      products: {
        title: 'Produkte',
        types: 'Typen',
        newProduct: 'Neues Produkt',
        productsTab: 'Produkte',
        stockTab: 'Bestand und Verfugbarkeit',
        updated: 'Produkt aktualisiert',
        created: 'Produkt erstellt',
        deleteConfirm: 'Produkt loschen?',
        deleted: 'Produkt geloscht',
        availabilityUpdated: 'Verfugbarkeit aktualisiert',
        viewInStore: 'Im Shop ansehen',
      },
      events: {
        eventUpdated: 'Event aktualisiert',
        eventCreated: 'Event erstellt',
        tournamentTypeGroups: 'Gruppenphase + K.-o.',
        tournamentTypeLeague: 'Liga (jeder gegen jeden)',
        tournamentTypeSwiss: 'Schweizer System (ausgewogen)',
      },
    },
  },
};
